module.exports = __webpack_public_path__ + "img/car-control.092d2cb9.svg";